import React from "react"; 
import Header from "../../components/header";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import IndividualAssessmentsTab from "./IndividualAssessmentsTab";
import UnifiedAssessmentsTab from "./UnifiedAssessmentsTab";
import "./styles.scss"; 

const ImpactAssessmentPage: React.FC = () => { 
  return (
    <>
      <div className="MyTeam">
        <Header title="Minha Equipe - Avaliação de Impacto" />
        <h2>Avaliação de impacto</h2>
        <Tabs>
          <TabList>
            <Tab>Avaliações Individuais</Tab>
            <Tab>Avaliações Unificadas</Tab>
          </TabList>
          <TabPanel>
            <IndividualAssessmentsTab />
          </TabPanel>
          <TabPanel>
            <UnifiedAssessmentsTab />
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default ImpactAssessmentPage;
